import { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  RFIS_SORTED_STATUSES,
  StatusDropdownOptionValue,
  getStringifyStatusDropdownOptionFunc,
  translate,
} from '../../../helpers';
import { StatusCell } from '../../StatusCell';
import { MultiSelectDropdown } from '../MultiSelectDropdown';
import { CommonFormField } from '../../Form';

type SelectedStatus = {
  label: JSX.Element;
  value: StatusDropdownOptionValue;
};

type StatusDropDownProps = {
  disabled?: boolean;
  selectedStatuses?: string[];
  onChange: (selectedStatuses: SelectedStatus[]) => void;
  'data-testid'?: string;
};

const stringifyStatusDropdownOption = getStringifyStatusDropdownOptionFunc(false);

const StatusDropDown = ({
  disabled,
  selectedStatuses,
  onChange,
  'data-testid': dataTestId,
}: StatusDropDownProps) => {
  const [selectedStatusFilters, setSelectedStatusFilters] = useState<SelectedStatus[]>([]);

  const statusOptions = useMemo(
    () =>
      RFIS_SORTED_STATUSES.map((status) => ({
        label: <StatusCell status={status} stacked={false} />,
        value: status,
      })),
    [],
  );

  useEffect(() => {
    setSelectedStatusFilters(
      statusOptions.filter((status) => selectedStatuses?.includes(status.value)),
    );
  }, [selectedStatuses, statusOptions]);

  return (
    <CommonFormField label={translate('rpPlugin.new.status')}>
      <MultiSelectDropdown
        selectedItems={selectedStatusFilters}
        options={statusOptions}
        disabled={disabled}
        onChange={onChange}
        placeholder={translate('rpPlugin.filter.status')}
        clearable
        itemToString={stringifyStatusDropdownOption}
        data-testid={dataTestId}
      />
    </CommonFormField>
  );
};

StatusDropDown.propTypes = {
  disabled: PropTypes.bool,
  selectedStatuses: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

StatusDropDown.defaultProps = {
  disabled: false,
};

export default StatusDropDown;
